import SharedAmenities from "../shared-amenities";

export interface InfoPromoAmenitiesProps {
  title: string;
  description: string;
  facility: {
    id: string;
    label: string;
    is_new: boolean;
    icon: string;
  }[];
}

export default function InfoPromoAmenities(props: InfoPromoAmenitiesProps) {
  return (
    <div className="bg-coffebrown xl:py-28 py-8">
      <div className="w-full xl:max-w-screen-xl mx-auto px-10 xl:px-0">
        <SharedAmenities
          title={props.title}
          description={props.description}
          facility={props.facility}
        />
      </div>
    </div>
  );
}
